import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  List,
  ListItem,
  Typography,
  makeStyles,
} from '@material-ui/core';

import { appConfig } from '../../../config/app';
import { PaymentsTypes } from '../../../constants/policies.constant';
import { useAuthDataContext } from '../../../context/auth/auth.provider';
import { useVehiclesContext } from '../../../context/vehicles/vehicles.provider';
import { getFormattedDate } from '../../../helpers/getDate';

const useStyles = makeStyles(() => ({
  header: {
    '-webkit-print-color-adjust': 'exact',
    background: '#2B2B2B',
    // background: 'linear-gradient(85.75deg, #0033A0 0%, rgba(0, 51, 160, 0.7) 100%)',
  },
  text: {
    color: '#000',
    fontFamily: 'Inter',
    // color: theme.palette.secondary.contrastText,
  },
  listItemRoot: {
    paddingTop: 2,
    paddingBottom: 2,
  },
  cardItemRoot: {
    padding: 2,
  },
  icon: {
    display: 'flex',
    margin: 5,
    padding: 10,
  },
}));

const VehicleDetails = () => {
  const { user } = useAuthDataContext();
  const { vehicle, getVehicleById } = useVehiclesContext();
  const { id }: any = useParams();
  const history = useHistory();
  const classes = useStyles();

  let CirculationCardImg = appConfig?.IMAGES?.CIRCULATION_CARD;

  useEffect(() => {
    if (id) {
      getVehicleById(id);
    } else {
      history.goBack();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const getVisibleDetails = () => [
    {
      name: 'Asegurado',
      value: (user.first_name || '') + ' ' + (user.last_name || ''),
    },
    {
      name: 'Modelo y versión',
      value:
        vehicle.model.split(' ')[0] +
        ' ' +
        vehicle.model.split(' ').slice(1).join(' '),
    },
    {
      name: 'Año',
      value: vehicle.year,
    },
    {
      name: 'Patente',
      value: vehicle.license_plate,
    },
    {
      name: 'Póliza',
      value: vehicle.policy.number,
    },
    {
      name: 'Vigencia',
      value:
        getFormattedDate(vehicle.policy.starts_at) +
        ' al ' +
        getFormattedDate(vehicle.policy.expires_at),
    },
    {
      name: 'N° de motor',
      value: vehicle.engine_number,
    },
    {
      name: 'N° de chasis',
      value: vehicle.chassis_number,
    },
    {
      name: 'Medio de pago',
      value: PaymentsTypes[vehicle.policy.payment_type],
    },
  ];

  return (
    Object.keys(vehicle).length && (
      <Card>
        <CardHeader
          className={classes.header}
          title={
            <Typography
              color="textSecondary"
              style={{ color: '#FFF', fontFamily: 'Inter' }}
            >
              {`${vehicle.brand} ${vehicle.model.split(' ')[0]}`}
            </Typography>
          }
          action={
            <Grid className={classes.icon}>
              <CirculationCardImg />
            </Grid>
          }
        ></CardHeader>
        <CardContent classes={{ root: classes.cardItemRoot }}>
          <List>
            {getVisibleDetails().map((item: any, index: number) => (
              <ListItem key={index} classes={{ root: classes.listItemRoot }}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  width="100%"
                >
                  <Typography
                    variant="caption"
                    style={{ color: '#000', fontFamily: 'Inter' }}
                  >
                    {item.name}{' '}
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    align="right"
                    style={{
                      color: '#000',
                      fontFamily: 'Inter',
                      fontWeight: 'bold',
                    }}
                  >
                    {item.value}
                  </Typography>
                </Box>
              </ListItem>
            ))}
          </List>
        </CardContent>
      </Card>
    )
  );
};

export default VehicleDetails;
